import { render, staticRenderFns } from "./FormularioDFD.vue?vue&type=template&id=ff28d4a8&scoped=true"
import script from "./FormularioDFD.vue?vue&type=script&lang=js"
export * from "./FormularioDFD.vue?vue&type=script&lang=js"
import style0 from "./FormularioDFD.vue?vue&type=style&index=0&id=ff28d4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff28d4a8",
  null
  
)

export default component.exports